import { VolumeMapper } from '@/modules/audio/mappers/volume.mapper';
import { IEpisodeDetailsDTO } from '@/modules/episodes/dtos/episode.dto';
import { IEpisodeDetails } from '@/modules/episodes/entities/episode.entity';

export class EpisodeDetailsMapper {
  public static toPresentation(episodeDetails: IEpisodeDetailsDTO): IEpisodeDetails {
    return {
      id: episodeDetails.id,
      title: episodeDetails.titulo,
      description: episodeDetails.descricao,
      role: {
        id: episodeDetails.cargo.id,
        name: episodeDetails.cargo.nome,
      },
      podcastName: episodeDetails.nomePodcast,
      voicesInUse:
        episodeDetails.vozesEmUso?.map((voice) => ({
          id: voice.id,
          name: voice.nome,
          slug: voice.slug,
          gender: voice.genero,
        })) ?? [],
      musicInUse: episodeDetails.musicaEmUso
        ? {
            id: episodeDetails.musicaEmUso.id,
            name: episodeDetails.musicaEmUso.nome,
            description: episodeDetails.musicaEmUso.descricao,
            previewUrl: episodeDetails.musicaEmUso.previewAudio,
          }
        : null,
      status: episodeDetails.status,
      thumbnail: episodeDetails?.thumbnail,
      author: episodeDetails.criadoPor,
      number: episodeDetails.numero,
      createdAt: episodeDetails.criadoEm,
      thumbName: episodeDetails.nomeImagem,
      updatedAt: episodeDetails.atualizadoEm,
      endedAt: episodeDetails.dataFinalizacao,
      duration: episodeDetails.duracao / 1000,
      ...VolumeMapper.toPresentation(episodeDetails),
    };
  }

  public static toDTO(episodeDetails: IEpisodeDetails): IEpisodeDetailsDTO {
    return {
      id: episodeDetails.id,
      titulo: episodeDetails.title,
      descricao: episodeDetails.description,
      cargo: {
        id: episodeDetails.role.id,
        nome: episodeDetails.role.name,
      },
      nomePodcast: episodeDetails.podcastName,
      vozesEmUso:
        episodeDetails.voicesInUse.map((voice) => ({
          id: voice.id,
          nome: voice.name,
          genero: voice.gender,
          slug: voice.slug,
        })) ?? [],
      musicaEmUso: episodeDetails.musicInUse
        ? {
            id: episodeDetails.musicInUse.id,
            nome: episodeDetails.musicInUse.name,
            descricao: episodeDetails.musicInUse.description,
            previewAudio: episodeDetails.musicInUse.previewUrl,
          }
        : null,
      status: episodeDetails.status,
      thumbnail: episodeDetails?.thumbnail,
      criadoPor: episodeDetails.author,
      numero: episodeDetails.number,
      criadoEm: episodeDetails.createdAt,
      nomeImagem: episodeDetails.thumbName,
      atualizadoEm: episodeDetails.updatedAt,
      dataFinalizacao: episodeDetails.endedAt,
      duracao: episodeDetails.duration * 1000,
      ...VolumeMapper.toDTO(episodeDetails),
    };
  }
}
